var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-tag-setup.html';
var html = "<div class=fat-padding><div class=row><div class=col-sm-8><h1 class=text-left>{{ 'sites.dashboard.widgets.dashboardWidgetTagSetup.tagu_settei_ga' | translate }}</h1><p translate=sites.dashboard.widgets.dashboardWidgetTagSetup.ko_no_tagugamausuyasukurooru translate-value=\"<br>\"></p><zcs-set-tag-button project=$ctrl.project></zcs-set-tag-button></div><div class=\"col-sm-4 text-right\"><svg-embed url=\"'/assets/img/illustration-tag-setting.svg'\"></svg-embed></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-tag-setup.html
// module id = 1414
// module chunks = 0